import {GovErrorCode, GovIcon, GovSpacer} from "@gov-design-system-ce/react";

export function SystemMaintenanceContent() {
    return (
        <div>
            <GovSpacer size="l"></GovSpacer>
            <GovErrorCode>
                <h2 className="gov-text--6xl">V aktuální chvíli probíhá údržba systému.</h2>
                {/*<p className="gov-text--l">Na obnově služeb</p>*/}
                <GovSpacer size="l"></GovSpacer>
                <GovIcon type="basic" name="offline" slot="icon"></GovIcon>
            </GovErrorCode>
        </div>
    )
}
